import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyACDeNdL3Wt0zTNUwbnLFyGmOyolxKvwqk",
  authDomain: "softov.firebaseapp.com",
  databaseURL: "https://softov.firebaseio.com",
  projectId: "softov",
  storageBucket: "softov.firebasestorage.app",
  messagingSenderId: "737049875826",
  appId: "1:737049875826:web:3cce26d78130f5cbb079eb",
  measurementId: "G-1TQ6566L6L"
};

let firebaseApp = null;
let messagingInstance = null;
let supportChecked = false;
let isMessagingSupported = false;

/**
 * 🔥 Firebase app singleton
 */
const getFirebaseApp = () => {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }
  return firebaseApp;
};

/**
 * 📡 Messaging singleton (only if supported)
 */
const getMessagingInstance = async () => {
  if (!supportChecked) {
    isMessagingSupported = await isSupported();
    supportChecked = true;
  }

  if (!isMessagingSupported) return null;

  if (!messagingInstance) {
    const app = getFirebaseApp();
    messagingInstance = getMessaging(app);
  }

  return messagingInstance;
};

/**
 * 🧍 MUST be called from user gesture (click / tap)
 */
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) return false;

  const permission = await Notification.requestPermission();
  return permission === "granted";
};

/**
 * 🔑 Safe to call AFTER permission is granted
 * No side-effects, no listeners, no re-init
 */
export const getFCMTokenAfterPermission = async () => {
  const messaging = await getMessagingInstance();
  if (!messaging) return null;

  const vapidKey = localStorage.getItem("firebasePublic");
  if (!vapidKey) return null;

  return getToken(messaging, { vapidKey });
};
